PJQ.integrations.views.IntegrationsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'integrations')
    },
    events: {
        'click .btn-settings': 'integrationClicked',
        'click .btn-connect': 'integrationClicked',
        'click .btn-disconnect': 'disconnectIntegration'
    },
    beforeFirstRender: function () {
        this.isFetched = false;
        PJQ.app.session.fetchIntegrations(_.bind(function (integrations) {
            this.integrations = integrations;
            this.isFetched = true;
            this.render();
        }, this))
    },
    renderData: function () {
        return {
            integrations: this.integrations,
            getIntegration: this.getIntegration
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.options.initOptions != null && _.size(this.options.initOptions.integrationName) > 0) {
            this.handleIntegrationType(this.options.initOptions.integrationName);
            this.options.initOptions = null;
        }
    },
    getIntegration: function (type) {
        if (this.integrations == null) {
            return null;
        }

        return this.integrations.find((ig) => {
            return ig.get('name') === type.toUpperCase()
        });
    },
    integrationClicked: function (e) {
        let $target = $(e.currentTarget),
            integrationType = $target.data('name');
        this.handleIntegrationType(integrationType);
    },
    handleIntegrationType: function (type, integration) {
        if (integration == null) {
            integration = this.getIntegration(type);
        }
        let enabled = integration != null;
        if (!enabled) {
            this.authorizeIntegration(type);
            return;
        }

        switch (type.toUpperCase()) {
            case PJQ.constants.integrations.providers.QBO.name:
                return new PJQ.integrations.views.QBOIntegrationSettings({
                    model: integration,
                    initOptions: this.options.initOptions
                });
            case PJQ.constants.integrations.providers.SAGE100.name:
            case PJQ.constants.integrations.providers.SAGE300.name:
                return new PJQ.integrations.views.SageHH2IntegrationSettings({
                    model: integration,
                    initOptions: this.options.initOptions,
                    onSave: _.bind(function (integration) {
                        this.integrations.add(integration);
                        PJQ.app.session.erpIntegration = integration;
                        PJQ.app.navigator.refreshCommands();
                        this.render();
                    }, this)
                });
            case PJQ.constants.integrations.providers.ACUMATICA.name:
                return new PJQ.integrations.views.AcumaticaIntegrationSettings({
                    model: integration,
                    initOptions: this.options.initOptions,
                    onSave: _.bind(function (integration) {
                        if (integration.id > 0) {
                            this.integrations.add(integration);
                            PJQ.app.session.erpIntegration = integration;
                            PJQ.app.navigator.refreshCommands();
                        }
                        this.render();
                    }, this)
                });
            case PJQ.constants.integrations.providers.INTACCT.name:
                return new PJQ.integrations.views.SageIntacctIntegrationSettings({
                    model: integration,
                    initOptions: this.options.initOptions,
                    onSave: _.bind(function (integration) {
                        this.integrations.add(integration);
                        PJQ.app.session.erpIntegration = integration;
                        PJQ.app.navigator.refreshCommands();
                        this.render();
                    }, this)
                });

            // case PJQ.constants.integrations.providers.VIEWPOINT_VISTA.name:
            //     return new PJQ.integrations.views.VistaIntegrationSettings({
            //         model: integration,
            //         initOptions: this.options.initOptions,
            //         onSave: _.bind(function (integration) {
            //             this.integrations.add(integration);
            //             PJQ.app.session.erpIntegration = integration;
            //             PJQ.app.navigator.refreshCommands();
            //             this.render();
            //         }, this)
            //     });
        }
    },
    authorizeIntegration: function (type) {
        let integration = this.getIntegration(type);
        if (integration == null) {
            integration = new PJQ.integrations.models.Integration({
                name: type,
                erp: true
            });
        }

        integration.authorize().then((authorized) => {
            if (authorized) {
                this.handleIntegrationType(type, integration);
            }
        }).catch((err) => {

        });
    },
    disconnectIntegration: function (e) {
        let $target = $(e.currentTarget),
            name = $target.data('name'),
            integration = this.integrations.findWhere({
                name: name
            }),
            displayName = PJQ.constants.integrations.providers[integration.get('name')].displayName;
        new PJQ.views.modals.YesNo({
            header: "Disconnect Integration?",
            body: "Are you sure you want to disconnect your " + displayName + " integration?  <strong>This will unlink all synced items and cannot be undone.</strong> ",
            onYes: _.bind(function () {
                if (integration != null) {
                    integration.destroy({
                        success: _.bind(function () {
                            PJQ.app.session.erpIntegration = new PJQ.integrations.models.Integration({}, {
                                erp: true
                            });
                            PJQ.app.navigator.refreshCommands();
                            PJQ.notifications.notify.successNotify({
                                message: 'Integration successfully disconnected'
                            });
                            this.render();
                        }, this)
                    });
                }
            }, this)
        });
    }
});

PJQ.integrations.views.QBOIntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-qbo'),
        minWidth: 500
    },
    events: {
        'change .input-projects': 'render',
        'change .input-import-single-item': 'render',
        'change .input-export-single-item': 'render',
        'change .input-sync-costs': 'render',
        'click .btn-re-auth': 'reAuthorize',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.costCodes = await PJQ.app.session.fetchCostCodes();
        this.costTypes = await PJQ.app.session.fetchCostTypes();
        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            integrationName: PJQ.constants.integrations.providers[this.model.get('name')].displayName,
            model: this.model,
            costCodes: this.costCodes,
            costTypes: this.costTypes,
            settings: this.model.get('settings'),
            isFetched: this.isFetched,
            newAuth: this.options.initOptions && this.options.initOptions.authorized
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.options.initOptions && this.options.initOptions.authorized) {
            PJQ.notifications.notify.successNotify({
                message: 'QuickBooks Online Integration successfully authorized'
            });
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ]
        });

        let incomeAccount = this.model.getSetting('incomeAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-income-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Income Account ' + PJQ.constants.markup.requiredAst,
            title: 'The income account used when pushing Cost Codes to QuickBooks Online Products',
            showSaveButton: false,
            defaultDisplayValue: incomeAccount != null ? incomeAccount.name : null,
            value: incomeAccount != null ? incomeAccount.id : null,
            getChoices: (cb) => {
                this.fetchAccounts(() => {
                    cb(_.sortBy(_.map(this.incomeAccounts, function (account) {
                        return {
                            id: account.id,
                            name: account.name
                        };
                    }), (account) => {
                        return account.name;
                    }));
                });
            },
            onChange: (value) => {
                let account = this.incomeAccounts.find((item) => item.id === value);
                if (account != null) {
                    this.model.setSetting('incomeAccount', account);
                }
            }
        });

        let expenseAccount = this.model.getSetting('expenseAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-expense-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Expense Account ' + PJQ.constants.markup.requiredAst,
            title: 'The expense account used when pushing Cost Codes to QuickBooks Online Products',
            showSaveButton: false,
            defaultDisplayValue: expenseAccount != null ? expenseAccount.name : null,
            value: expenseAccount != null ? expenseAccount.id : null,
            getChoices: (cb) => {
                this.fetchAccounts(() => {
                    cb(_.sortBy(_.map(this.expenseAccounts, function (account) {
                        return {
                            id: account.id,
                            name: account.name
                        };
                    }), (account) => {
                        return account.name;
                    }));
                });
            },
            onChange: (value) => {
                let account = this.expenseAccounts.find((item) => item.id === value);
                if (account != null) {
                    this.model.setSetting('expenseAccount', account);
                }
            }
        });

        let paymentAccount = this.model.getSetting('paymentAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-payment-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Payment Account ' + PJQ.constants.markup.requiredAst,
            title: 'The payment account used when pushing Direct Costs to QuickBooks Online Purchases',
            showSaveButton: false,
            defaultDisplayValue: paymentAccount != null ? paymentAccount.name : null,
            value: paymentAccount != null ? paymentAccount.id : null,
            getChoices: (cb) => {
                this.fetchAccounts(() => {
                    cb(_.sortBy(_.map(this.paymentAccounts, function (account) {
                        return {
                            id: account.id,
                            name: account.name
                        };
                    }), (account) => {
                        return account.name;
                    }));
                });
            },
            onChange: (value) => {
                let account = this.paymentAccounts.find((item) => item.id === value);
                if (account != null) {
                    this.model.setSetting('paymentAccount', account);
                }
            }
        });

        let incomeDefaultItem = this.model.getSetting('incomeDefaultItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-income-default-item'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Export Income Product ' + PJQ.constants.markup.requiredAst,
            title: 'The product used when syncing Contracts, Contract Change Orders, and Receivable Invoices to QuickBooks Online',
            showSaveButton: false,
            defaultDisplayValue: incomeDefaultItem != null ? (incomeDefaultItem.name + ' ' + incomeDefaultItem.description) : null,
            value: incomeDefaultItem != null ? incomeDefaultItem.id : null,
            getChoices: (cb) => {
                this.fetchProducts(() => {
                    cb(_.sortBy(_.map(_.filter(this.products, function (product) {
                        return product.forIncome;
                    }), function (product) {
                        return {
                            id: product.id,
                            name: product.name + ' ' + product.description
                        };
                    }), (product) => {
                        return product.name;
                    }));
                });
            },
            onChange: (value) => {
                let product = this.products.find((item) => item.id === value);
                if (product != null) {
                    this.model.setSetting('incomeDefaultItem', product);
                }
            }
        });

        let expenseDefaultItem = this.model.getSetting('expenseDefaultItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-expense-default-item'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Export Expense Product ' + PJQ.constants.markup.requiredAst,
            title: 'The product used when syncing Commitments, Commitment Change Orders, and Payable Invoices to QuickBooks Online',
            showSaveButton: false,
            defaultDisplayValue: expenseDefaultItem != null ? (expenseDefaultItem.name + ' ' + expenseDefaultItem.description) : null,
            value: expenseDefaultItem != null ? expenseDefaultItem.id : null,
            getChoices: (cb) => {
                this.fetchProducts(() => {
                    cb(_.sortBy(_.map(_.filter(this.products, function (product) {
                        return product.forExpense;
                    }), function (product) {
                        return {
                            id: product.id,
                            name: product.name + ' ' + product.description
                        };
                    }), (product) => {
                        return product.name;
                    }));
                });
            },
            onChange: (value) => {
                let product = this.products.find((item) => item.id === value);
                if (product != null) {
                    this.model.setSetting('expenseDefaultItem', product);
                }
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-default-group'),
            isLiveSearch: true,
            isIntChoices: true,
            choices: _.map(this.costCodes.models.sort(function (a, b) {
                return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('code'), b.get('code'));
            }), function (costCode) {
                return {
                    id: costCode.id,
                    name: costCode.getDisplayName()
                };
            }),
            defaultValue: this.model.get('settings').costDefaultGroupId,
            onChange: _.bind(function (value) {
                this.model.get('settings').costDefaultGroupId = value;
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-default-cost-type'),
            isLiveSearch: true,
            isIntChoices: true,
            choices: _.map(this.costTypes.models, function (costType) {
                return {
                    id: costType.id,
                    name: costType.get('name')
                };
            }),
            defaultValue: this.model.get('settings').costDefaultCostTypeId,
            onChange: _.bind(function (value) {
                this.model.get('settings').costDefaultCostTypeId = value;
            }, this)
        });
    },
    fetchAccounts: function (callback) {
        if (this.expenseAccounts != null && this.incomeAccounts != null && this.paymentAccounts != null) {
            if (typeof callback === 'function') {
                callback();
            }
            return;
        }

        this.model.fetchSettingsData(null, {
            type: 'accounts'
        }).then((data) => {
            if (data != null) {
                this.expenseAccounts = data.expenseAccounts ?? [];
                this.incomeAccounts = data.incomeAccounts ?? [];
                this.paymentAccounts = data.paymentAccounts ?? [];
            }
            if (typeof callback === 'function') {
                callback();
            }
        }).catch((err) => {

        });
    },
    fetchProducts: function (callback) {
        if (this.products != null) {
            if (typeof callback === 'function') {
                callback();
            }
            return;
        }

        this.model.fetchSettingsData((data) => {
            if (data != null) {
                this.products = data.products ?? [];
            }
            if (typeof callback === 'function') {
                callback();
            }
        }, {
            type: 'products'
        });
    },
    reAuthorize: function () {
        new PJQ.views.modals.YesNo({
            header: "Re-Authorize QuickBooks Online Integration?",
            body: "Are you sure you want to re-authorize your QuickBooks Online integration? This is usually only necessary if you have made changes to the user you used during setup, or if you are experiencing issues with your integration.",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.model.authorize().then((authorized) => {
                    if (authorized) {
                        this.render();
                    }
                }).catch((err) => {
                    loader.remove();
                });
            }
        });
    },
    validate: function () {
        let settings = this.model.get('settings'),
            valid = true;

        if (settings.incomeAccount == null) {
            valid = false;
            this.$('.label-income-account').addClass('text-danger');
        }

        if (settings.expenseAccount == null) {
            valid = false;
            this.$('.label-expense-account').addClass('text-danger');
        }

        if (settings.paymentAccount == null) {
            valid = false;
            this.$('.label-payment-account').addClass('text-danger');
        }

        if (settings.exportSingleItem) {
            if (settings.incomeDefaultItem == null) {
                valid = false;
                this.$('.label-income-default-item').addClass('text-danger');
            }

            if (settings.expenseDefaultItem == null) {
                valid = false;
                this.$('.label-expense-default-item').addClass('text-danger');
            }
        }

        if (settings.syncProjects && settings.syncCosts) {
            if (settings.importSingleItem && settings.costDefaultGroupId == null) {
                valid = false;
                this.$('.label-cost-default-group').addClass('text-danger');
            }

            if (settings.costDefaultCostTypeId == null) {
                valid = false;
                this.$('.label-cost-default-cost-type').addClass('text-danger');
            }
        }

        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Settings updated successfully'
                    });
                    this.removeModal();
                }, this)
            })
        }
    },
    setSettings: function (callback) {
        if (typeof callback === 'function') {
            callback(settings);
        }
    },
});

PJQ.integrations.views.SageHH2IntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-sage-hh2'),
        minWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
            this.costCodes = costCodes;
            PJQ.app.session.fetchCostTypes(_.bind(function (ct) {
                this.costTypes = ct;
                this.isFetched = true;
                this.render();
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            provider: PJQ.constants.integrations.providers[this.model.get('name')],
            model: this.model,
            settings: this.model.get('settings'),
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.renderAlerts();
            }, this)
        });

        this.renderAlerts();
    },
    renderAlerts: function () {

    },
    validate: function () {
        let settings = this.model.get('settings'),
            valid = true;
        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (this.validate()) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.save(null, {
                success: () => {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Settings updated successfully'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    this.removeModal();
                }
            })
        }
    }
});

PJQ.integrations.views.AcumaticaIntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-acumatica'),
        minWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save, .btn-authorize': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink',
        'change .input-export-single-item': 'render',
        'click .btn-edit-auth': 'editAuthorization',
        'click .btn-cancel-auth': 'cancelEditingAuthorization'
    },
    beforeModalCreated: function () {
        this.settingsData = {};

        this.isFetched = false;
        PJQ.app.session.fetchCostCodes((costCodes) => {
            this.costCodes = costCodes;
            PJQ.app.session.fetchCostTypes((ct) => {
                this.costTypes = ct;
                this.options.isAuthorized = true;
                this.options.editingAuthorization = false;

                if (this.model.id == null) {
                    this.options.editingAuthorization = true;
                    this.options.isAuthorized = false;
                }

                if (null == this.model.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS)) {
                    this.model.setSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS, this.model.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS));
                }

                this.isFetched = true;
                this.render();
            });
        });
    },
    renderData: function () {
        return {
            provider: PJQ.constants.integrations.providers[this.model.get('name')],
            model: this.model,
            settings: this.model.get('settings'),
            isFetched: this.isFetched,
            editingAuthorization: this.options.editingAuthorization,
            isAuthorized: this.options.isAuthorized
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: () => {
                this.renderAlerts();
            }
        });

        let version = this.model.get('settings').version != null ? this.model.get('settings').version : null;
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-api-version'),
            defaultValue: version ? version : '',
            onChange: (value) => {
                this.model.get('settings').version = value;
                this.renderCustomizationLink();
            }
        });
        this.renderCustomizationLink();

        let defaultIncomeAccountGroup = this.model.getSetting('defaultIncomeAccountGroup');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-income-account'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Income Account Group ' + PJQ.constants.markup.requiredAst,
            title: 'The account group used when syncing Contracts to Acumatica Project Revenue Budgets',
            showSaveButton: false,
            defaultDisplayValue: defaultIncomeAccountGroup != null ? defaultIncomeAccountGroup.accountGroupID : null,
            value: defaultIncomeAccountGroup != null ? defaultIncomeAccountGroup.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    let incomeAccounts = _.filter(this.settingsData.accountGroups, function (account) {
                        return account.type.toLowerCase() === "income";
                    })
                    cb(_.map(incomeAccounts, function (account) {
                        return {
                            id: account.id,
                            name: account.accountGroupID
                        };
                    }));
                };
                if (this.settingsData.accountGroups != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'account_groups'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.accountGroups.find((item) => item.id === value);
                if (item != null) {
                    this.model.setSetting('defaultIncomeAccountGroup', item);
                }
            }
        });

        let defaultSalesSubaccount = this.model.getSetting('defaultSalesSubaccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-sales-subaccount'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Sales Subaccount',
            title: 'The subaccount used when syncing projects to Acumatica',
            showSaveButton: false,
            defaultDisplayValue: defaultSalesSubaccount != null ? defaultSalesSubaccount.subaccountID : null,
            value: defaultSalesSubaccount != null ? defaultSalesSubaccount.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    let subaccounts = _.filter(this.settingsData.subaccounts, function (subaccount) {
                        return true;
                    })
                    cb(_.map(subaccounts, function (subaccount) {
                        return {
                            id: subaccount.id,
                            name: subaccount.subaccountID
                        };
                    }));
                };
                if (this.settingsData.subaccounts != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'sub_accounts'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.subaccounts.find((item) => item.id === value);
                if (item != null) {
                    this.model.setSetting('defaultSalesSubaccount', item);
                }
            }
        });

        let defaultCreditTerms = this.model.getSetting('defaultCreditTerms');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-credit-terms'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Credit Terms ' + PJQ.constants.markup.requiredAst,
            title: 'The Credit Terms used when syncing Commitments to Acumatica Subcontracts and Purchase Orders',
            showSaveButton: false,
            defaultDisplayValue: defaultCreditTerms != null ? defaultCreditTerms.termsID : null,
            value: defaultCreditTerms != null ? defaultCreditTerms.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.creditTerms, function (cls) {
                        return {
                            id: cls.id,
                            name: cls.termsID
                        };
                    }));
                };
                if (this.settingsData.creditTerms != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'credit_terms'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.creditTerms.find((item) => item.id === value);
                if (item != null) {
                    this.model.setSetting('defaultCreditTerms', item);
                }
            }
        });

        let defaultNonStockItem = this.model.getSetting('defaultNonStockItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-nonstock'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Non-Stock Item ' + PJQ.constants.markup.requiredAst,
            title: 'The Non-Stock Item used when syncing Commitments to Acumatica Subcontracts and Purchase Orders',
            showSaveButton: false,
            defaultDisplayValue: defaultNonStockItem != null ? defaultNonStockItem.inventoryID : null,
            value: defaultNonStockItem != null ? defaultNonStockItem.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.nonStockItems, function (item) {
                        return {
                            id: item.id,
                            name: item.inventoryID
                        };
                    }));
                };
                if (this.settingsData.nonStockItems != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'non_stock_items'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.nonStockItems.find((item) => item.id === value);
                if (item != null) {
                    this.model.setSetting('defaultNonStockItem', item);
                }
            }
        });

        let primeContractCOClass = this.model.getSetting('primeContractCOClass');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-pcco-class'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Contract CO Class ' + PJQ.constants.markup.requiredAst,
            showSaveButton: false,
            defaultDisplayValue: primeContractCOClass != null ? primeContractCOClass.classID : null,
            value: primeContractCOClass != null ? primeContractCOClass.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.primeContractCOClasses, function (cls) {
                        return {
                            id: cls.id,
                            name: cls.classID
                        };
                    }));
                };
                if (this.settingsData.primeContractCOClasses != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'change_order_class'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.primeContractCOClasses.find((item) => item.id === value);
                if (item != null) {
                    this.model.setSetting('primeContractCOClass', item);
                }
            }
        });

        let commitmentCOClass = this.model.getSetting('commitmentCOClass');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-cco-class'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Commitment CO Class ' + PJQ.constants.markup.requiredAst,
            showSaveButton: false,
            defaultDisplayValue: commitmentCOClass != null ? commitmentCOClass.classID : null,
            value: commitmentCOClass != null ? commitmentCOClass.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.commitmentCOClasses, function (cls) {
                        return {
                            id: cls.id,
                            name: cls.classID
                        };
                    }));
                };
                if (this.settingsData.commitmentCOClasses != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'change_order_class'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.commitmentCOClasses.find((item) => item.id === value);
                if (item != null) {
                    this.model.setSetting('commitmentCOClass', item);
                }
            }
        });

        let vendorClass = this.model.getSetting('vendorClass');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-vendor-class'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Vendor Class ' + PJQ.constants.markup.requiredAst,
            showSaveButton: false,
            defaultDisplayValue: vendorClass != null ? vendorClass.classID : null,
            value: vendorClass != null ? vendorClass.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.vendorClasses, function (cls) {
                        return {
                            id: cls.id,
                            name: cls.classID
                        };
                    }));
                };
                if (this.settingsData.vendorClasses != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'vendor_class'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.vendorClasses.find((item) => item.id === value);
                if (item != null) {
                    this.model.setSetting('vendorClass', item);
                }
            }
        });

        this.renderAlerts();
    },
    renderCustomizationLink: function () {
        let ver = this.model.get('settings').version,
            fileName = '',
            $pkg = this.$('.customization-package');
        if (ver === '24.200.001') {
            fileName = 'JP[24.206.0014][2025.01.10]';
        } else if (ver === '23.200.001') {
            fileName = 'JobPlanner2023R2';
        } else if (ver === '22.200.001') {
            fileName = 'JobPlanner2022R1';
        } else {
            $pkg.empty();
            return;
        }
        $pkg.html('<a class="fs-14" href="' + PJQ.app.options.apiV2Url + '/public/integrations/acumatica/' + fileName + '.zip" target="_blank">Download Customization Package</a>');
    },
    editAuthorization: function () {
        this.options.editingAuthorization = true;
        this.render();
    },
    cancelEditingAuthorization: function () {
        this.options.editingAuthorization = false;
        this.render();
    },
    renderAlerts: function () {

    },
    validate: function () {
        let settings = this.model.get('settings'),
            valid = true;


        if (settings.defaultIncomeAccountGroup == null && !this.options.editingAuthorization) {
            valid = false;
            this.$('.edit-income-account .form-group > label').addClass('text-danger');
        }

        if (settings.defaultCreditTerms == null && !this.options.editingAuthorization) {
            valid = false;
            this.$('.edit-default-credit-terms .form-group > label').addClass('text-danger');
        }

        if (settings.defaultNonStockItem == null && !this.options.editingAuthorization) {
            valid = false;
            this.$('.edit-default-nonstock .form-group > label').addClass('text-danger');
        }

        if (settings.primeContractCOClass == null && !this.options.editingAuthorization) {
            valid = false;
            this.$('.edit-pcco-class .form-group > label').addClass('text-danger');
        }

        if (settings.commitmentCOClass == null && !this.options.editingAuthorization) {
            valid = false;
            this.$('.edit-cco-class .form-group > label').addClass('text-danger');
        }


        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (this.validate()) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.save(null, {
                success: () => {
                    loader.remove();

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    if (!this.options.editingAuthorization) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Settings updated successfully'
                        });
                        this.removeModal();
                    } else {
                        PJQ.notifications.notify.successNotify({
                            message: 'Successfully Authorized'
                        });
                        this.options.editingAuthorization = false;
                        this.options.isAuthorized = true;
                        this.render();
                    }
                },
                error: () => {
                    loader.remove();
                    this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
                        type: 'danger',
                        text: 'Unable to validate the integration. Double check your information is correct.'
                    });
                }
            })
        }
    }
});

PJQ.integrations.views.VistaIntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-viewpoint-vista'),
        minWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
            this.costCodes = costCodes;
            PJQ.app.session.fetchCostTypes(_.bind(function (ct) {
                this.costTypes = ct;
                this.isFetched = true;
                this.render();
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            provider: PJQ.constants.integrations.providers[this.model.get('name')],
            model: this.model,
            settings: this.model.get('settings'),
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.renderAlerts();
            }, this)
        });

        this.renderAlerts();
    },
    renderAlerts: function () {

    },
    validate: function () {
        let settings = this.model.get('settings'),
            valid = true;
        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (this.validate()) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.save(null, {
                success: () => {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Settings updated successfully'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    this.removeModal();
                }
            })
        }
    }
});

PJQ.integrations.views.SageIntacctIntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-sage-intacct'),
        minWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save, .btn-authorize': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink',
        'click .btn-edit-auth': 'editAuthorization',
        'click .btn-cancel-auth': 'cancelEditingAuthorization'
    },
    beforeModalCreated: function () {
        this.settingsData = {};

        this.isFetched = false;
        PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
            this.costCodes = costCodes;
            PJQ.app.session.fetchCostTypes(_.bind(function (ct) {
                this.costTypes = ct;
                this.options.isAuthorized = true;
                this.options.editingAuthorization = false;

                if (this.model.id == null) {
                    this.options.editingAuthorization = true;
                    this.options.isAuthorized = false;
                }

                if (null == this.model.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS)) {
                    this.model.setSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS, this.model.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS));
                }

                this.isFetched = true;
                this.render();
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            provider: PJQ.constants.integrations.providers[this.model.get('name')],
            model: this.model,
            settings: this.model.get('settings'),
            isFetched: this.isFetched,
            editingAuthorization: this.options.editingAuthorization,
            isAuthorized: this.options.isAuthorized
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
            }, this)
        });

        let fnGetAccounts = (cb, options) => {
                let accounts = _.filter(this.settingsData.glAccounts, function (glAccount) {
                    return true;
                })
                cb(_.map(_.filter(accounts, (account) => {
                    if (!options || !options.normalBalance) {
                        return true;
                    }

                    return account.normalBalance === options.normalBalance;
                }), function (account) {
                    return {
                        id: account.accountNo,
                        name: `${account.accountNo} - ${account.title}`
                    };
                }));
            },
            defaultPayableAccount = this.model.getSetting('defaultPayableAccount'),
            defaultReceivableAccount = this.model.getSetting('defaultReceivableAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-receivable-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Receivable Account ' + PJQ.constants.markup.requiredAst,
            title: 'The default account used when pushing Contracts to Sage Intacct',
            showSaveButton: false,
            selectPickerOptions: {
                isLiveSearch: true
            },
            defaultDisplayValue: defaultReceivableAccount != null ? `${defaultReceivableAccount.accountNo} - ${defaultReceivableAccount.title}` : null,
            value: defaultReceivableAccount != null ? defaultReceivableAccount.recordNo : null,
            getChoices: (cb) => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                if (this.settingsData.glAccounts != null) {
                    fnGetAccounts(cb, {
                        normalBalance: 'debit'
                    });
                    loader.remove();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnGetAccounts(cb, {
                        normalBalance: 'debit'
                    });
                    loader.remove();
                }, {
                    type: 'gl_accounts'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.glAccounts.find((item) => item.accountNo === value);
                if (item != null) {
                    this.model.setSetting('defaultReceivableAccount', item);
                }
            }
        });

        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-payable-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Payable Account ' + PJQ.constants.markup.requiredAst,
            title: 'The default Account used when pushing Payable Invoices (Bills) to Sage Intacct',
            showSaveButton: false,
            selectPickerOptions: {
                isLiveSearch: true
            },
            defaultDisplayValue: defaultPayableAccount != null ? `${defaultPayableAccount.accountNo} - ${defaultPayableAccount.title}` : null,
            value: defaultPayableAccount != null ? defaultPayableAccount.recordNo : null,
            getChoices: (cb) => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                if (this.settingsData.glAccounts != null) {
                    fnGetAccounts(cb, {
                        normalBalance: 'credit'
                    });
                    loader.remove();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnGetAccounts(cb, {
                        normalBalance: 'credit'
                    });
                    loader.remove();
                }, {
                    type: 'gl_accounts'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.glAccounts.find((item) => item.accountNo === value);
                if (item != null) {
                    this.model.setSetting('defaultPayableAccount', item);
                }
            }
        });

        let defaultItem = this.model.getSetting('defaultItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-item-id'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Item ' + PJQ.constants.markup.requiredAst,
            title: 'The default Item used when pushing Contracts to Sage Intacct',
            showSaveButton: false,
            defaultDisplayValue: defaultItem != null ? `${defaultItem.itemId} - ${defaultItem.name}` : null,
            value: defaultItem != null ? defaultItem.recordNo : null,
            getChoices: (cb) => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                let fnCallback = () => {
                    loader.remove();
                    let items = _.filter(this.settingsData.items, function (glAccount) {
                        return true;
                    })
                    cb(_.map(items, function (item) {
                        return {
                            id: item.itemId,
                            name: `${item.itemId} - ${item.name}`
                        };
                    }));
                };
                if (this.settingsData.items != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'items'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.items.find((item) => item.itemId === value);
                if (item != null) {
                    this.model.setSetting('defaultItem', item);
                }
            }
        });

        let defaultEntity = this.model.getSetting('defaultEntity');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-entity'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Entity',
            title: 'The default entity used when pushing new project locations to Sage Intacct',
            showSaveButton: false,
            defaultDisplayValue: defaultEntity != null ? `${defaultEntity.locationId} - ${defaultEntity.name}` : null,
            value: defaultEntity != null ? defaultEntity.recordNo : null,
            getChoices: (cb) => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                let fnCallback = () => {
                    loader.remove();
                    let entities = _.filter(this.settingsData.entities, function (glAccount) {
                        return true;
                    })
                    cb(_.map(entities, function (entity) {
                        return {
                            id: entity.locationId,
                            name: `${entity.locationId} - ${entity.name}`
                        };
                    }));
                };
                if (this.settingsData.entities != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'entities'
                });
            },
            onChange: (value) => {
                let entity = this.settingsData.entities.find((entity) => entity.locationId === value);
                if (entity != null) {
                    this.model.setSetting('defaultEntity', entity);
                }
            }
        });
    },
    editAuthorization: function () {
        this.options.editingAuthorization = true;
        this.render();
    },
    cancelEditingAuthorization: function () {
        this.options.editingAuthorization = false;
        this.render();
    },
    validate: function () {
        if (this.options.editingAuthorization) {
            return true;
        }

        let settings = this.model.get('settings'),
            valid = true;
        if (settings.defaultReceivableAccount == null) {
            valid = false;
            this.$('.edit-default-receivable-account .form-group > label').addClass('text-danger');
        }

        if (settings.defaultPayableAccount == null) {
            valid = false;
            this.$('.edit-default-payable-account .form-group > label').addClass('text-danger');
        }

        if (settings.defaultItem == null) {
            valid = false;
            this.$('.edit-default-item-id .form-group > label').addClass('text-danger');
        }
        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (this.validate()) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.save(null, {
                success: () => {
                    loader.remove();

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    if (!this.options.editingAuthorization) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Settings updated successfully'
                        });
                        this.removeModal();
                    } else {
                        PJQ.notifications.notify.successNotify({
                            message: 'Successfully Authorized'
                        });
                        this.options.editingAuthorization = false;
                        this.options.isAuthorized = true;
                        this.render();
                    }
                },
                error: () => {
                    loader.remove();
                    this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
                        type: 'danger',
                        text: 'Unable to validate the integration. Double check your information is correct.'
                    });
                }
            })
        }
    }
});